package gr.tech.site.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initHallofflowersPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/hallofflowers.md", FrontMatterElement.Builder { addScalar("title", "Hall of Flowers 2026"); addScalar("description", "Our experience at Hall of Flowers, connecting with cultivators, showcasing rebates for LEDs, HVAC, and other upgrades, and highlighting the fun and energy of the cannabis trade show. Learn how they help commercial growers maximize incentives while celebrating the culture."); addScalar("author", "Ethan Cohen"); addScalar("image", "/images/blog/hallofflowers2026.JPG"); addScalar("date", "2026-03-23"); addScalar("updated", "2026-03-23"); addList("tags") { addScalar(""); }; }))
}

@Page("/blog/hall-of-flowers-2026")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun HallofflowersPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("let-me-holla-at-some-flowers") }) {
        org.jetbrains.compose.web.dom.Text("Let Me Holla At Some Flowers")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Finally, a trade show that didn’t consist of a one hour uber to LAX, waiting in security for 45 minutes, and boarding a plane only to sit next to someone crying while watching Michael Scott’s last episode of The Office. I’m not mad that they were watching it, but also I never signed up to relive the saddest moment in TV history. All in all, it was nice to hop in my car, hit highway 101, and exhibit on the west coast, the birthplace of cannabis culture.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.hallofflowers.com/") {
            org.jetbrains.compose.web.dom.Text("Hall Of Flowers")
        }
        org.jetbrains.compose.web.dom.Text(" wasn’t the typical trade show we’ve grown accustomed to. It’s a show that caters to dispensaries looking to buy new and exciting products to highlight at their stores. It’s where new cannabis strains can truly set themselves apart and gain the notoriety they deserve. It also caters to consumers who can walk around and buy high quality weed for cheaper than ever. Sure, tickets are pricey, but if you’re a daily cannabis user, it nearly offsets.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When folks stopped by our booth and asked what services we provided, they looked more confused than a Jehovah's Witness at a weed event. As day one progressed, so did the quality of my pitch. Here’s a sample interaction after day 2.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Attendee - “So what’s ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/") {
            org.jetbrains.compose.web.dom.Text("Green Rebates")
        }
        org.jetbrains.compose.web.dom.Text("? What do you guys do?”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Me - “Give me ${'$'}20 for this hat. Okay, now here’s a ${'$'}20 rebate. We do that x1000 for commercial growers.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Attendee - “Wow. Take my money!”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Me - “No, you take MY money!”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Anyone who knows Green Rebates knows that we love playing games at trade shows, and Hall Of Flowers was no exception. This time we rolled out “")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/p/DWAN3u5v2yr/") {
            org.jetbrains.compose.web.dom.Text("Green Jeopardy")
        }
        org.jetbrains.compose.web.dom.Text(",” where cannabis experts could put their knowledge to the test and try to win up to ${'$'}120. The categories were Strains, Cultivation, Rebates, Pop Culture, History, and Science. Strains was the hottest category, and most people got stumped by the question about ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.allbud.com/marijuana-strains/indica-dominant-hybrid/chemdawg") {
            org.jetbrains.compose.web.dom.Text("Chemdawg")
        }
        org.jetbrains.compose.web.dom.Text(". There’s strength in knowledge, but also strength in understanding that you’ll never know everything. Even attendees who taught college courses about cannabis were caught off guard by a few questions!")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The “Bloom & Blaze” after party by ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://cannamanagementgroup.com/") {
            org.jetbrains.compose.web.dom.Text("Canna Management Group")
        }
        org.jetbrains.compose.web.dom.Text(" was probably the coolest party I’ve ever attended, trade shows aside. It took place at ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://thevictorianhouseventura.com/") {
            org.jetbrains.compose.web.dom.Text("The Victorian House")
        }
        org.jetbrains.compose.web.dom.Text(" in Ventura, and after it reached capacity, a few folks got caught jumping the fence from the side of the venue. You know you’re at the right party when people are risking their freedom just to get in.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Sure, the main goal of trade shows is to connect with cultivators and see if there’s an opportunity to get them paid for purchasing LEDs, dehumidifiers, HVAC equipment etc. But at a show like Hall Of Flowers, showing face and giving attendees a memorable experience can be just as impactful for our brand. We’re not just nerds who crunch numbers, we’re passionate about the plant and showing love to those still fighting the good fight no matter how tough the industry has gotten over the last few years.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you or somebody you know is a commercial cultivator looking to upgrade, it’d be a bad move to not contact ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/") {
            org.jetbrains.compose.web.dom.Text("Green Rebates")
        }
        org.jetbrains.compose.web.dom.Text(" beforehand. We can search every nook & cranny to get you the biggest rebate possible, and the fee we take on the backend is never as big as the extra money we can find you on the frontend. ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/contact-us/") {
            org.jetbrains.compose.web.dom.Text("Get a free estimate today!")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Related:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/the-2026-guide-to-cannabis-rebates-how-to-get-paid-for-your-grow-upgrades") {
                org.jetbrains.compose.web.dom.Text("The 2026 Guide to Cannabis Rebates: How to Get Paid for Your Grow Upgrades")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/top-10-high-efficiency-led-rebates-for-commercial-cultivators-in-2026") {
                org.jetbrains.compose.web.dom.Text("Top 10 High-Efficiency LED Rebates for Commercial Cultivators in 2026")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/the-thc-girls-and-guy-stopped-by-podcast") {
                org.jetbrains.compose.web.dom.Text("The THC Girls (and Guy) Stopped By | Podcast")
            }
        }
    }
}
